export default __webpack_public_path__ + "static/media/s_wdt_c_1.da3fd8c0.mp3";